export default {
  // License status (shared by DeviceLicense and ProductionToken burn records)
  'pages.deviceLicense.status.allocated': 'Recorded',
  'pages.deviceLicense.status.activated_pending': 'Activated, pending connection',
  'pages.deviceLicense.status.active': 'Connected',
  'pages.deviceLicense.status.serial_mismatch': 'Device eFuse serial does not match platform',
  'pages.deviceLicense.status.revoked': 'Revoked',
  'pages.deviceLicense.status.expired': 'Expired',
  'pages.deviceLicense.burnStatus.pending': 'Not burned',
  'pages.deviceLicense.burnStatus.success': 'Burn succeeded',

  // DeviceLicense
  'pages.deviceLicense.column.serialNumber': 'Production serial No.',
  'pages.deviceLicense.column.burnStatus': 'Burn status',
  'pages.deviceLicense.column.productionTokenName': 'Production token',
  'pages.deviceLicense.rule.tenantRequired': 'Please select a tenant',
  'pages.deviceLicense.rule.deviceIdRequired': 'Please enter the device MAC',
  'pages.deviceLicense.batch.tooltip': 'Separate by comma, space, or newline; duplicates are removed automatically',
  'pages.deviceLicense.batch.devicesRequired': 'Please enter the device MAC list',

  // TenantInfo
  'pages.tenantInfo.rule.nameRequired': 'Please enter the company name',
  'pages.tenantInfo.type.commercial': 'Commercial',
  'pages.tenantInfo.type.legacy': 'Legacy/Retail',
  'pages.tenantInfo.type.internal': 'Internal',
  'pages.tenantInfo.status.active': 'Active',
  'pages.tenantInfo.status.inactive': 'Disabled',
  'pages.tenantInfo.maxDevices.tooltip': 'Maximum number of device licenses for this company; you can also accumulate via "Add capacity" in the list',
  'pages.tenantInfo.addMax.button': 'Add capacity',
  'pages.tenantInfo.addMax.success': 'Added. Current total device capacity: {count}',
  'pages.tenantInfo.addMax.failed': 'Operation failed',
  'pages.tenantInfo.addMax.incrementLabel': 'Amount to add',
  'pages.tenantInfo.addMax.incrementRequired': 'Please enter a quantity greater than 0',

  // ProductionToken
  'pages.productionToken.title': 'Production Burn Tokens',
  'pages.productionToken.filterHint':
    'The list is filtered by product category (ID: {id}). Remove the URL parameter to view all.',
  'pages.productionToken.firmware.currentNoCategory': '{version} (current, no product category bound)',
  'pages.productionToken.firmware.currentNotInList': '{version} (current / not in list)',

  'pages.productionToken.column.tenant': 'Tenant',
  'pages.productionToken.column.productCategoryId': 'Product category ID',
  'pages.productionToken.column.name': 'Name',
  'pages.productionToken.column.boardType': 'Board type',
  'pages.productionToken.column.status': 'Status',
  'pages.productionToken.column.burnedLimit': 'Issued / Limit',
  'pages.productionToken.column.serialIssued': 'Serials issued',
  'pages.productionToken.column.autoAllocate': 'Auto-allocate MAC',
  'pages.productionToken.column.serialPrefix': 'Serial prefix',
  'pages.productionToken.column.lastUsedAt': 'Last used',
  'pages.productionToken.column.expiresAt': 'Token expiry',

  'pages.productionToken.status.enabled': 'Enabled',
  'pages.productionToken.status.disabled': 'Disabled',
  'pages.productionToken.yes': 'Yes',
  'pages.productionToken.no': 'No',

  'pages.productionToken.action.burnRecords': 'Burn records',
  'pages.productionToken.action.edit': 'Edit',
  'pages.productionToken.action.rotate': 'Rotate',
  'pages.productionToken.action.add': 'New token',
  'pages.productionToken.confirm.delete': 'Delete this token?',

  'pages.productionToken.msg.rotateFailed': 'Rotation failed',
  'pages.productionToken.msg.deleted': 'Deleted',
  'pages.productionToken.msg.deleteFailed': 'Delete failed',
  'pages.productionToken.msg.createSuccess': 'Created successfully',
  'pages.productionToken.msg.createFailed': 'Creation failed',
  'pages.productionToken.msg.saved': 'Saved',
  'pages.productionToken.msg.saveFailed': 'Save failed',
  'pages.productionToken.msg.loadBurnFailed': 'Failed to load burn records',

  'pages.productionToken.rule.tenantRequired': 'Please select a tenant',
  'pages.productionToken.rule.categoryRequired': 'Please select a product category',

  'pages.productionToken.add.title': 'New Production Token',
  'pages.productionToken.add.categoryLabel': 'Product category (board type)',
  'pages.productionToken.add.categoryTooltip':
    'Choose from the product categories maintained by this tenant; the board type is taken from the category\'s "device model", consistent with OTA board.type and the ota_bin subdirectory',
  'pages.productionToken.add.firmwareTooltip':
    'Leave empty to use the production default or the latest firmware of the category; options come from firmware uploaded under this product category',
  'pages.productionToken.add.autoAllocateTooltip':
    'When disabled, only devices with pre-registered MACs can fetch licenses',
  'pages.productionToken.add.expiresTooltip': 'Optional, date only; leave empty for no expiry',

  'pages.productionToken.edit.title': 'Edit Production Token',
  'pages.productionToken.edit.firmwareTooltip':
    'Leave empty to use the production default or the latest firmware of the category; options come from the firmware list under the category bound to this token',
  'pages.productionToken.edit.expiresTooltip':
    'Optional; saving after clearing it will not change the expiry here (clearing the expiry requires future API support)',

  'pages.productionToken.field.firmwareVersion': 'Locked firmware version',
  'pages.productionToken.field.serialPrefix': 'Serial number prefix',
  'pages.productionToken.field.autoAllocate': 'Auto-allocate MAC license',
  'pages.productionToken.field.maxBurnCount': 'Max burn count',
  'pages.productionToken.field.maxBurnTooltip': '0 means unlimited',
  'pages.productionToken.field.expiresAt': 'Token expiry time',
  'pages.productionToken.field.remark': 'Remark',
  'pages.productionToken.field.status': 'Status',

  'pages.productionToken.placeholder.selectVersion': 'Please select a version',
  'pages.productionToken.placeholder.selectCategoryFirst': 'Please select a product category first',

  'pages.productionToken.secret.title': 'Save now (the plaintext token cannot be viewed again after closing)',
  'pages.productionToken.secret.saved': 'Saved',
  'pages.productionToken.secret.urlLabel':
    "License URL template (write to license_url in the burn tool's config.json)",

  'pages.productionToken.burn.title': 'Burn records',
  'pages.productionToken.burn.titleWith': 'Burn records — {name}',
  'pages.productionToken.burn.boardInfo': 'Board type: {boardType}; devices with issued serials: ',
  'pages.productionToken.burn.limitSuffix': ' / limit {max}',
  'pages.productionToken.burn.column.deviceId': 'Device MAC',
  'pages.productionToken.burn.column.serialNumber': 'Production serial No.',
  'pages.productionToken.burn.column.status': 'License status',
  'pages.productionToken.burn.column.boardType': 'Model',
  'pages.productionToken.burn.column.burnedAt': 'Issued at',
  'pages.productionToken.burn.column.activatedAt': 'First connected',
  'pages.productionToken.burn.column.source': 'Source',

  // Common (shared across pages)
  'pages.common.operation': 'Operation',
  'pages.common.deleteSuccess': 'Deleted successfully',
  'pages.common.deleteFailed': 'Delete failed',
  'pages.common.saveSuccess': 'Saved successfully',
  'pages.common.saveFailed': 'Save failed',

  // Tenant (columns/form/enums shared, used by TenantInfo)
  'pages.tenant.logo.typeError': 'Only image files can be uploaded',
  'pages.tenant.logo.sizeError': 'Image size cannot exceed 1MB',
  'pages.tenant.logo.success': 'Uploaded successfully',
  'pages.tenant.logo.uploadFailed': 'Upload failed',
  'pages.tenant.logo.upload': 'Upload logo',
  'pages.tenant.logo.clear': 'Remove',
  'pages.tenant.modal.title': 'Company info',
  'pages.tenant.modal.profileTitle': 'Edit company profile',
  'pages.tenant.column.code': 'License code',
  'pages.tenant.code.tip': 'The license code is generated by the system and cannot be modified',
  'pages.tenant.code.auto': 'Generated automatically after saving',
  'pages.tenant.column.name': 'Company name',
  'pages.tenant.column.type': 'Type',
  'pages.tenant.column.status': 'Status',
  'pages.tenant.column.maxDevices': 'Total device capacity',
  'pages.tenant.column.contactName': 'Contact',
  'pages.tenant.column.contactPhone': 'Contact phone',
  'pages.tenant.column.expiresAt': 'Expiry date',
  'pages.tenant.column.remark': 'Remark',
  'pages.tenant.column.supplierLogo': 'Company logo',
  'pages.tenant.column.activatedDevices': 'Activated devices',
  'pages.tenant.column.licensedDevices': 'Licensed devices',
  'pages.tenant.column.availableDevices': 'Available device licenses',
  'pages.tenant.maxDevices.unlimited': 'Unlimited',
  'pages.tenant.confirm.delete': 'Delete this company?',
  'pages.tenant.add': 'Add company',

  // License (columns/form shared, used by DeviceLicense)
  'pages.license.column.tenant': 'Tenant',
  'pages.license.column.deviceId': 'Device MAC',
  'pages.license.column.status': 'Status',
  'pages.license.column.batchNo': 'Batch No.',
  'pages.license.column.boardType': 'Model',
  'pages.license.column.source': 'License source',
  'pages.license.source.manual': 'Manual',
  'pages.license.source.import': 'Batch import',
  'pages.license.source.production': 'Production issue',
  'pages.license.source.production_preregister': 'Production pre-register',
  'pages.license.source.legacy_migrate': 'Legacy migrate',
  'pages.license.column.activatedAt': 'First connected',
  'pages.license.column.createdAt': 'Recorded at',
  'pages.license.column.expiresAt': 'Expiry date',
  'pages.license.confirm.delete': 'Delete this license?',
  'pages.license.add': 'Add license',
  'pages.license.batchAdd': 'Batch import',
  'pages.license.modal.addTitle': 'Add device license',
  'pages.license.batch.title': 'Batch import device licenses',
  'pages.license.batch.devices': 'Device MAC',
  'pages.license.batch.result': 'Import complete: {added} added, {skipped} skipped',
};
